import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { AutoCreatePurchaseCtrl }     from './purchase-order.auto-create';
import { CreateOrderFromInvoiceCtrl } from './purchase-order.create';
import { InvoiceAttachedOrdersCtrl }  from './purchase-order.attached';
import { OpenOrdersCtrl }             from './purchase-order.orders-open';
import { PurchaseOrderCtrl }          from './purchase-order';
import { PurchaseOrderService }       from './purchase-order.service';
import { PurchaseOrdersStates }       from './purchase-orders.states.ajs';
import { PurchaseOrderStatusFilter }  from './purchase-order.status.filter.ajs';
import { PurchaseOrderStatusPipe }    from './purchase-order.status.pipe';
import { RepcoPurchaseOrderListCtrl } from './purchase-order.repco';

angular.module('workshop.purchaseOrders', [])
  .config(PurchaseOrdersStates)
  .controller('autoCreatePurchaseCtrl', AutoCreatePurchaseCtrl)
  .controller('createOrderFromInvoiceCtrl', CreateOrderFromInvoiceCtrl)
  .controller('InvoiceAttachedOrdersCtrl', InvoiceAttachedOrdersCtrl)
  .controller('OpenOrdersCtrl', OpenOrdersCtrl)
  .controller('purchaseOrderCtrl', PurchaseOrderCtrl)
  .controller('repcoPOList', RepcoPurchaseOrderListCtrl)
  .factory('Order', PurchaseOrderService)
  .filter('purchaseOrderStatus', PurchaseOrderStatusFilter)
  .service('purchaseOrderStatusPipe', downgradeInjectable(PurchaseOrderStatusPipe));

